import { useSearchParams } from 'react-router-dom';
import * as React from 'react';

export function useHighlightRowByUrl(rows: any[]) {
  const [searchParams] = useSearchParams();
  const highlightColumn = searchParams.get('highlightCol');
  const highlightValue = searchParams.get('highlightVal');

  const matchRowByHighlight = React.useCallback(
    (row: Record<string, unknown>) =>
      highlightColumn &&
      highlightValue != null &&
      row[highlightColumn] != null &&
      String(row[highlightColumn]) === highlightValue,
    [highlightColumn, highlightValue],
  );

  const selectedRowId = React.useMemo(() => {
    if (!highlightColumn || highlightValue == null) return undefined;
    const match = rows.find(matchRowByHighlight);
    return match ? (match as { id?: string | number }).id : undefined;
  }, [rows, highlightColumn, highlightValue, matchRowByHighlight]);

  return {
    highlightColumn,
    highlightValue,
    matchRowByHighlight,
    selectedRowId,
  };
}
